import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { GenericError } from '@cian/peperrors/shared';
import { selectPuids } from '../../selectors/adfox';
import { FC } from 'react';

const Adfox = connect(props => <AdFoxTemplates deviceType="desktop" {...props} />);

export const AdfoxPixelContainer: FC = () => {
  const { logger } = useApplicationContext();
  const puids = useSelector(selectPuids);

  if (!puids) {
    return null;
  }

  const onStubHandle = () => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: 'adfoxStub',
        details: { developerId: puids.puid39 },
      }),
    );
  };

  const onErrorHandle = (event: { type: string }) => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: event.type,
        details: { developerId: puids.puid39 },
      }),
    );
  };

  return (
    <Adfox
      onError={onErrorHandle}
      onStub={onStubHandle}
      params={{ p1: 'cyrbe', p2: 'frfe', ...puids }}
      width="1"
      height={1}
    />
  );
};
